/** Legacy empty action lists mean all. Never encode an explicit denial as []. */
export function setHostedAgentToolAction({
  tools,
  toolActions,
  tool,
  action,
  allActions,
  checked,
}: {
  tools: string[]
  toolActions: Record<string, string[]>
  tool: string
  action: string
  allActions: string[]
  checked: boolean
}) {
  // An action editor must not silently enable an unselected tool, nor accept
  // a stale/unknown catalog action as a request to broaden permissions.
  if (!tools.includes(tool) || !allActions.includes(action)) return { tools, toolActions }
  const current = toolActions[tool] ?? []
  const base = current.length ? current : allActions
  const next = checked ? [...new Set([...base, action])] : base.filter((item) => item !== action)
  const updated = { ...toolActions }
  if (next.length === 0) {
    delete updated[tool]
    return { tools: tools.filter((item) => item !== tool), toolActions: updated }
  }
  // Keep explicit grants explicit. Checking all currently known actions must
  // not also grant future actions introduced by a later catalog version.
  updated[tool] = next
  return { tools, toolActions: updated }
}
